import { Table, Button, Pagination, ButtonGroup } from "flowbite-react";
import { HiPencil, HiPlus, HiTrash } from "react-icons/hi";
import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";
import { routes } from "../routes";
import { useReducerAsState } from "../hooks/useReducerAsState";
import { TableResults } from "../components";
import useAuthors from "../hooks/useAuthors";

interface State {
    page: number;
    limit: number;
}

const AuthorsPage = () => {
    const { authors, loading, error, fetchAuthors, totalAuthors, deleteAuthor } = useAuthors();

    const [state, setState] = useReducerAsState<State>({
        limit: 10,
        page: 1,
    })

    const navigate = useNavigate();

    const onPageChange = (page: number) => setState({page})

    const handleCreate = () => navigate(`${routes.DASHBOARD}/${routes.AUTHORS}/create`)

    const onDelete = async (id: number | undefined) => {
        if(!id) return;
        const confirm = window.confirm("¿Está seguro que desea eliminar este autor?")
        if(!confirm) return;
        const hasDeleted = await deleteAuthor(id) 
        if(!hasDeleted) return;
        await fetchAuthors({...state})
    }

    useEffect(() => {
        (async () => {
            await fetchAuthors({...state})
        })()
        // eslint-disable-next-line
    } ,[state.page])

    return <div className="m-4">
        <div className="flex flex-col mb-4">
            <div className="mb-4">
                <h1>Autores</h1>
            </div>

            <div className="flex flex-row justify-between items-end">
               
                <div className="flex flex-row">
                    <Button onClick={handleCreate}>
                        <HiPlus className="mr-2 h-5 w-5" />
                        Crear autor
                    </Button>
                </div>
            </div>
        </div>
        

        <TableResults
            loading={loading}
            error={error}
            itemsCount={totalAuthors}
        >
            <div className="overflow-x-auto mb-4 w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                <Table>
                    <Table.Head>
                        <Table.HeadCell>Nombre</Table.HeadCell>
                        <Table.HeadCell>
                        </Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                        {authors && authors.map((item) => <Table.Row key={item.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                            <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                {item.name}
                            </Table.Cell>
                            <Table.Cell>
                                <ButtonGroup>
                                    <Button onClick={() => navigate(`${routes.DASHBOARD}/${routes.AUTHORS}/${item.id}`)} color="gray">
                                        <HiPencil />
                                    </Button>
                                    <Button onClick={() => onDelete(item.id)} color="failure">
                                        <HiTrash />
                                    </Button>
                                </ButtonGroup>
                            </Table.Cell>
                        </Table.Row>)}
                    </Table.Body>
                </Table>
            </div>
        </TableResults>
        {authors.length > 0 && <div className="flex overflow-x-auto sm:justify-center">
            <Pagination currentPage={state.page || 1} totalPages={Math.ceil(totalAuthors / state.limit)} onPageChange={onPageChange} />
        </div>}
    </div>
}

export default AuthorsPage;